import type { ReactNode } from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { FloatingContact } from './FloatingContact';
import { LanternCursor } from './cursor/LanternCursor';
import { CursorSpotlight } from './zen/CursorSpotlight';
import { ScrollProgressRail } from './zen/ScrollProgressRail';
import { ZenEasterEgg } from './zen/ZenEasterEgg';
import { CardTiltEffect } from './interaction/CardTiltEffect';
import { PageViewBeacon } from './PageViewBeacon';
import { BackgroundProvider } from '../lib/scene/BackgroundProvider';

type Props = { children: ReactNode };

export function SiteShell({ children }: Props) {
  return (
    <>
      <BackgroundProvider />
      <CursorSpotlight />
      <Navbar />
      <main
        id="main-content"
        className="min-h-[calc(100dvh-var(--nav-height))] relative"
        style={{ paddingTop: 'var(--nav-height)', zIndex: 2 }}
      >
        {children}
      </main>
      <Footer />
      <FloatingContact />
      <ScrollProgressRail />
      <ZenEasterEgg />
      <CardTiltEffect />
      <LanternCursor />
      <PageViewBeacon />
    </>
  );
}
